module.exports = __webpack_public_path__ + "img/aral.7a67b586.png";